import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {getUser} from '../../../assets/utils.js';

@Component({
  selector: 'app-dashboard-sidebar',
  templateUrl: './dashboard-sidebar.component.html',
  styleUrls: ['./dashboard-sidebar.component.scss']
})
export class DashboardSidebarComponent implements OnInit {

  username = '';

  constructor(public router: Router ) {

    if (getUser()) {
      this.username = getUser().firstname;
    }
  }

  ngOnInit() {
  }

}
